import "./styles.css";
import { mount } from "./app.js";
import { isDocsPath, mountDocsPortal } from "./docs-portal.js";

/** Old public waitlist URLs. They open the homepage create-account form. */
function isJoinPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return p === "/join" || p === "/join-the-test";
}

const root = document.getElementById("app");
if (!root) {
  throw new Error("#app root element missing");
}

if (isJoinPath(window.location.pathname)) {
  const url = new URL(window.location.href);
  url.pathname = "/";
  url.searchParams.set("signup", "1");
  const next =
    url.pathname +
    (url.searchParams.toString() ? `?${url.searchParams}` : "") +
    url.hash;
  window.history.replaceState({}, "", next);
}

if (isDocsPath()) {
  mountDocsPortal(root);
} else {
  mount(root);
}
